import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SubnavComponent } from './subnav.component';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ SubnavComponent ],
    exports: [ SubnavComponent ],
})

export class SubnavModule {}
